import { render, staticRenderFns } from "./CHeader.vue?vue&type=template&id=237e203a&"
import script from "./CHeader.ts?vue&type=script&lang=ts&"
export * from "./CHeader.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports